import { AppConfig } from '@aipb/gulliver/env/util';
import { BrowserMiradorEnv } from './browser-mirador.env';

export class BrowserMiradorConfig extends AppConfig<BrowserMiradorEnv> {
  get quickModeDomains(): string[] {
    return this.config.quickModeDomains || [];
  }
}
